{
  "actions": "İşlemler",
  "activeStakes": "Aktif Stake'ler",
  "apy": "APY",
  "claimNow": "Şimdi Talep Et",
  "claimRewards": "Ödülleri Talep Et",
  "claimRewardsFailed": "Ödül talebi başarısız oldu.",
  "days": "Gün",
  "duration": "Süre",
  "enterExaltAmount": "EXALT Miktarı Girin",
  "enterStakeAmount": "Stake edilecek miktarı girin",
  "enterValidExaltAmount": "Lütfen geçerli bir EXALT miktarı girin.",
  "enterValidStakeAmount": "Lütfen geçerli bir stake miktarı girin.",
  "estimatedApr": "Tahmini APR",
  "estimatedRewards": "Tahmini Ödüller",
  "exaltStaking": "EXALT Staking",
  "insufficientBalance": "Yetersiz EXALT bakiyesi.",
  "loading": "Yükleniyor...",
  "lockPeriod": "Kilit Süresi",
  "minimumStake": "Minimum Stake",
  "nextReward": "Sonraki Ödül",
  "noActiveStakesYet": "Aktif staking pozisyonu bulunamadı.",
  "noRewardHistory": "Ödül geçmişi bulunmuyor.",
  "pendingReward": "Bekleyen Ödül",
  "processing": "İşleniyor...",
  "rewardHistory": "Ödül Geçmişi",
  "rewardRate": "Ödül Oranı",
  "rewardsClaimedSuccessfully": "Ödüller başarıyla talep edildi.",
  "rewardsEarned": "Kazanılan Ödüller",
  "securityNotice": "Güvenlik Bildirimi",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "stake": "Stake Et",
  "stakeCompleted": "Tamamlandı",
  "stakeExalt": "EXALT Stake Et",
  "stakeHistory": "Stake Geçmişi",
  "stakeNow": "Şimdi Stake Et",
  "stakingFailed": "Staking başarısız oldu.",
  "stakingSecurity1": "Ödüller arka uç doğrulaması sonrası yatırılır.",
  "stakingSecurity2": "Erken stake kaldırma kuralları geçerli olabilir.",
  "stakingSecurity3": "İstisnai durumlarda Sahip/Yönetici onayı gerekebilir.",
  "stakingSecurity4": "İşlemden önce blok zinciri onayları doğrulanır.",
  "stakingStartedSuccessfully": "Staking başarıyla başlatıldı.",
  "stakingSubtitle": "EXALT stake ederek güvenli pasif gelir kazanın.",
  "stakingTitle": "EXALT Staking",
  "totalRewards": "Toplam Ödüller",
  "totalStaked": "Toplam Stake Edilen",
  "unavailable": "Kullanılamıyor",
  "unstake": "Stake'i Kaldır",
  "unstakeFailed": "Stake kaldırma başarısız oldu.",
  "unstakeNow": "Şimdi Stake'i Kaldır",
  "unstakedSuccessfully": "Tokenlerin stake'i başarıyla kaldırıldı."
}